




































































import { Vue, Component, Prop } from 'vue-property-decorator';

const { AgGridVue } = require('ag-grid-vue');
import {
  GridOptions,
  GridApi,
  GridReadyEvent,
  ICellRendererParams,
  ColDef,
  ColumnApi,
  CellClickedEvent,
} from 'ag-grid-community';
import { LoadingService } from '@/services/loadingService';
import { Snotify } from '@/snotify/Snotify';

import { fetchMS } from './fetchMS';

@Component({ components: { GridComponent: AgGridVue } })
export default class ModalVerEstadoSeries extends Vue {
  @Prop({ default: false }) show: boolean;
  @Prop({ required: true, default: {} }) data!: any;

  columnApi: ColumnApi = null;
  gridOptions: GridOptions = null;
  gridEvent: GridReadyEvent = null;
  gridApi: GridApi = null;
  columnDefs: ColDef[] = [];
  quickSearch: string = '';
  loading: boolean = false;
  listData: any[] = [];
  dialog: boolean = false;

  readonly loadingService = new LoadingService();
  readonly $snotify: Snotify = null;

  mounted() {
    this.dialog = this.show;
  }

  constructor() {
    super();
    this.columnDefs = this.colsGrid();

    this.gridOptions = {
      columnDefs: this.columnDefs,
      pagination: true,
      paginationPageSize: 5,
      cacheBlockSize: 5,
      overlayNoRowsTemplate: 'No hay filas para mostrar',
      onGridReady: this.handleMainGridReady,
    };
  }

  private colsGrid() {
    const cols = [
      { id: 'serienumero', name: 'Número Serie' },
      { id: 'estado_inet', name: 'Estado INET' },
      { id: 'estado_crm', name: 'Estado CRM' },
      { id: 'estado_serieactiva_finalizada', name: 'Serie Activa Finalizada' },
      { id: 'asigcrm_alta', name: 'Alta CRM ' },
      { id: 'glosa_crm', name: 'Glosa CRM' },
      { id: 'glosa_inet', name: 'Glosa INET' },
    ];

    return cols.map(col => ({
      headerName: col.name,
      field: col.id,
      cellStyle: { textAlign: 'left' },
      resizable: true,
      width: 220,
      minWidth: 100,
    }));
  }

  async handleMainGridReady(event: GridReadyEvent): Promise<void> {
    this.gridApi = event.api;
    this.columnApi = event.columnApi;
    this.gridEvent = event;
    this.listData = await this.getEquipoActiva(this.data.asignumero);
    this.gridApi.setRowData(this.listData);
    this.gridApi.setDomLayout('autoHeight');
  }

  handleClosed(): void {
    this.dialog = false;
    this.data = {};
    this.$emit('cerrar');
  }

  handleSearch() {
    this.gridApi.setQuickFilter(this.quickSearch);
    this.gridApi.setDomLayout('autoHeight');
  }

  async getEquipoActiva(asignumero: string) {
    try {
      this.loading = true;
      this.loadingService.showLoading(null, 'getEquipoActiva');

      const result = await fetchMS({ asignumero }, 'get_equipo_activa');
      const { MENSAJE_RESPUESTA, CODIGO_RESPUESTA, LISTA } = result.data;
      const cod: number = Number(CODIGO_RESPUESTA);

      if (cod !== 1) {
        this.$snotify.error(MENSAJE_RESPUESTA, { timeout: 3000 });
        return [];
      }
      return LISTA;
    } catch (error) {
      console.error('Error: ', error);
      return [];
    } finally {
      this.loading = false;
      this.loadingService.hideLoading('getEquipoActiva');
    }
  }
}
